export const UPDATE_PRESENCA_ALUNOS = 'UDPATE_PRESENCA_ALUNOS'
export const SET_PRESENCA_ALUNOS = 'SET_PRESENCA_ALUNOS'
export const SET_PRESENCA_ALUNO = 'SET_PRESENCA_ALUNO'